module.exports = __webpack_public_path__ + "img/forbidden.69fbe83d.png";